import { render } from "./LoginLink.vue?vue&type=template&id=80626b68"
import script from "./LoginLink.vue?vue&type=script&lang=js"
export * from "./LoginLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__